module.exports = __webpack_public_path__ + "b0901f1868791233e0950c17f7868cbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/cities-countries/India2.jpg
// module id = 3314
// module chunks = 0